<template>
    <div class="main news-layout">
        <div class="container-fluid">
            <h1 class="container-title">A propos de {{ author }}</h1>
            <div class="news">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <h2 class="container-title">Nouvelles de {{ author }}</h2>
                        <article-card v-for="article in newsList" :key="article.path" :article="article"></article-card>
                    </div>
                    <div class="col-12 col-lg-6">
                        <h2 class="container-title">Analyses de {{ author }}</h2>
                        <article-card v-for="article in articlesList" :key="article.path" :article="article"></article-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DefaultLayout from "../../components/DefaultLayout.vue";
import createHeader from "../../js/meta.js";
import { buildNewsMenu } from "../../js/menu.js";
import moment from "moment";
import ArticleCard from "../../components/ArticleCard";

export default {
    components: {
        DefaultLayout,
        ArticleCard
    },
    methods: {
        dateFormat(dateStr) {
            return moment(dateStr)
                .locale("fr")
                .format("ll");
        }
    },
    data() {
        return {
            menu: []
        };
    },
    async asyncData({ $content, params }) {
        console.log(params);

        const newsList = await $content("actu")
            .where({ author: params.slug.trim() })
            .only([
                "title",
                "path",
                "img",
                "description",
                "date",
                "author",
                "readingTime"
            ])
            .sortBy("date", "desc")
            .fetch();
        const articlesList = await $content("articles")
            .where({ author: params.slug.trim() })
            .only([
                "title",
                "path",
                "img",
                "description",
                "date",
                "author",
                "readingTime"
            ])
            .sortBy("date", "desc")
            .fetch();
        return {
            author: params.slug,
            articlesList,
            newsList
        };
    },
    head() {
        // console.log(this);
        return createHeader({
            title: "Articles de " + this.author + " - Stakepool.fr",
            description:
                "Tous les articles de " + this.author + ", de Stakepool.fr",
            image: ""
        });
    }
};
</script>

<style>
article h1 {
    font-size: 50px;
}

p.metadata {
    margin-bottom: 0px;
}

span.posted-on,
span.readtime {
    margin-left: 20px;
}
</style>
